import { Text } from '../../cdl/Text/Text';
import { translate } from '../../common/helpers/translate.helper';
import { Box } from '../../common/ui/Box';
import { OfferModel } from '../model/OfferModel';

import { OfferChat } from './OfferChat';

interface OfferChatSectionProps {
    offer: OfferModel;
}

export const OfferChatSection = ({ offer }: OfferChatSectionProps) => {
    return (
        <Box>
            <Box paddingBottom={16}>
                <Text variant="title" as="h2">
                    {translate('offer.detail.chat')}
                </Text>
            </Box>

            <Box
                borderStyle="solid"
                borderWidth="1px"
                borderColor="border.muted"
                minHeight="350px"
                maxHeight="600px"
                overflow="hidden"
                height="calc(100% - 56px)"
            >
                <OfferChat offer={offer} />
            </Box>
        </Box>
    );
};
